import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import printJS from "lib/print-js";
import { Communications } from "modules/AppointmentDetails/components/DeskCommunicationLog/components";
import "modules/AppointmentDetails/components/DeskCommunicationLog/components/CommunicationLogs/CommunicationLogs.scss";

import type { Appointment } from "models";

type CommunicationLogsProps = {
  appointment: Appointment;
  isModalOpen: boolean;
  defaultTabActiveIndex?: number;
  onToggleIsModalOpen: (evt: React.MouseEvent) => void;
};

export const CommunicationLogs = ({ appointment, isModalOpen, defaultTabActiveIndex = 0, onToggleIsModalOpen }: CommunicationLogsProps) => {
  const { t } = useTranslation();

  const handlePrint = () => {
    printJS({
      printable: "CommunicationLogs-Content",
      type: "html",
      copyStyles: true,
      css: ["./CommunicationLogs.scss"],
      scanStyles: false,
      targetStyles: ["*"]
    });
  };

  if (!appointment.desk_communications) return null;

  return (
    <Modal open={isModalOpen} className="CommunicationLogs">
      <Modal.Header className="CommunicationLogs-Header">
        <div className="header-title">
          <Icon name="list" />
          <div>{t("v8_desk_comm_log", "Desk communication log")}</div>
        </div>

        <div className="modal-header-actions">
          <Button onClick={handlePrint} className="modal-print-btn" color="grey">
            {t("v8_print", "Print")}
            <Icon className="print" />
          </Button>
          <Button className="modal-close-btn" basic onClick={onToggleIsModalOpen}>
            <Icon className="xmark" />
          </Button>
        </div>
      </Modal.Header>

      <Modal.Content id="CommunicationLogs-Content" scrolling>
        <Communications appointment={appointment} desk_communications={appointment.desk_communications} defaultTabActiveIndex={defaultTabActiveIndex} />
      </Modal.Content>
    </Modal>
  );
};
